<template>
    

    <div class="main-content">
      <v-container>
        <!-- Campo de búsqueda -->
        <v-row>
          <v-col cols="12">
            <v-card class="pa-4" color="#f8f2e8" style="height:400px;  
         background-image: url(''); 
         background-size: contain;  /* Asegura que la imagen cubra el contenedor */
         background-position: center; /* Centra la imagen */
         background-repeat: no-repeat; /* Evita que la imagen se repita */
         height: 130%; /* Asegura que ocupe toda la altura del contenedor */
  ">

              <v-chip color="primary" variant="flat">
                <v-card-title class="text-white" style="font-size: 1rem;"> <!-- Aumenté el tamaño de la fuente -->
                Boones
                </v-card-title>
              </v-chip>



            </v-card>
            <v-card-text>
              <v-text-field v-model="searchQuery" append-inner-icon="mdi-magnify" density="compact"
                label="Buscar producto" variant="solo" hide-details class="search-field"></v-text-field>
            </v-card-text>
          </v-col>
          <v-col cols="12">

          </v-col>
        </v-row>
        <br> <br> <br>
        <!-- Boton de filtros -->
        <v-row justify="start">
          <v-col cols="auto">
            <v-btn variant="tonal" color="blue-darken-2" class="rounded-lg px-4 py-2 text-white"
              @click="dialogFiltro = true">
              <v-icon class="mr-2">mdi-filter-variant</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <!-- Filtro de precios menor que y mayor que -->
        <v-dialog v-model="dialogFiltro" max-width="420">
          <v-card class="rounded-lg">
            <v-card-title class="bg-grey-darken-4 text-white">
              <v-icon class="mr-2">mdi-filter-cog</v-icon> Filtrar y ordenar
            </v-card-title>

            <v-card-text class="py-4">
              <v-switch v-model="sortByPrice" color="black">
                <template v-slot:label>
                  <v-icon small class="mr-1"></v-icon>
                  <div>Precio <strong> De menor a mayor</strong></div>

                </template>
              </v-switch>

              <v-select v-model="selectedBrand" :items="brands" label="Filtrar por Marca" clearable variant="outlined"
                color="primary" dense>
                <template v-slot:prepend-item>
                  <v-icon left>mdi-filter</v-icon>
                </template>
              </v-select>

            </v-card-text>

            <v-card-actions class="justify-end bg-orange-lighten-3">

              <v-btn color="black" variant="flat" class="rounded-lg px-4 text-white" @click="applyFilters">
                <v-icon class="mr-1">mdi-check</v-icon> Aplicar
              </v-btn>


            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Botón del carrito flotante -->
        <v-tooltip location="bottom" origin="center" no-click-animation>
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props" @click="openCart" color="green-accent-3" class="fixed-cart-btn text-white"
              elevation="4">
              <v-icon left>mdi-cart-outline</v-icon>
              Ver Canasta ({{ totalCajas }})
            </v-btn>
          </template>
          <div>Total de cajas: {{ totalCajas }}</div>
        </v-tooltip>

        <br><br>



        <!-- Productos -->
        <v-row dense>
          <v-col v-for="(product) in filteredProducts" :key="product.id" cols="6" sm="6" md="4" lg="3"
            class="d-flex justify-center">
            <v-card class="pa-4" variant="transparent" style="width: 240px;">
              <v-row>
                <!-- Contenedor de los iconos y botones -->
                <div class="d-flex align-center" style="position: relative;">
                  <!-- Icono para agregar al carrito -->

                  <!-- Contenedor de botones (+) y (-) -->
                  <div v-if="getProductQuantity(product) > 0" class="d-flex align-center mt-2">
                    <!-- Botón para disminuir la cantidad -->
                    <v-btn icon @click="decreaseQuantity(product)" variant="transparent" density="compact" color="red">
                      <v-icon>mdi-minus-circle</v-icon>
                    </v-btn>

                    <!-- Mostrar la cantidad del producto -->
                    <span class="px-2 text-caption font-weight-bold" style="font-size: 1.2em;">
                      {{ getProductQuantity(product) }}
                    </span>

                    <!-- Botón para aumentar la cantidad -->
                    <v-btn icon @click="increaseQuantity(product)" density="compact" variant="transparent"
                      color="green-accent-3">
                      <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>



                  </div>
                </div>
              </v-row>

              <v-row class="d-flex justify-center" style="position: relative;">
                <v-col cols="9" style="position: relative;">
                  <!-- Imagen del producto -->
                  <v-img :src="product.foto || 'default-image-url'" height="100px" class="rounded" size="40" v-ripple
                    @click="addToCart(product)">
                  </v-img>

                  <!-- Icono de más sobre la imagen -->
                  <v-icon color="green-accent-3" size="32" v-ripple class="add-icon"
                    style="position: absolute; top: 5px; right: 5px; background: white; border-radius: 50%; padding: 2px; cursor: pointer;"
                    @click="getProductQuantity(product) === 0 && addToCart(product)"
                    :class="{ 'v-icon--disabled': getProductQuantity(product) > 0 }"
                    :style="getProductQuantity(product) > 0 ? 'pointer-events: none; opacity: 0;' : ''">
                    mdi-plus-circle
                  </v-icon>

                </v-col>
              </v-row>
              
                <div class="w-full text-center mt-2">
              <!-- Precio del producto -->
              <div class="text-base sm:text-lg md:text-xl font-semibold text-blue-700 shadow-sm">
                ${{ product.price }}
              </div>

              <!-- Nombre del producto -->
              <div class="text-xs sm:text-sm md:text-base font-medium text-gray-700">
                {{ product.nombre }}
              </div>
            </div>
            </v-card>
          </v-col>
        </v-row>
        <!-- Diálogo del carrito -->
        <CartDialog v-model="cartDialog" />



      </v-container>
    </div>
 
</template>

<script>
import axios from 'axios';
import CartDialog from '../Administrador/CarritoViewStore.vue'; // Asegúrate de que la ruta sea correcta
import { inject, computed } from 'vue';


export default {
  name: 'AntojitosView',
  components: {   CartDialog },
  setup() {
    // Inyectar el store del carrito
    const cartStore = inject('cartStore'); // Asegúrate de que 'cartStore' esté proporcionado globalmente

    // Usar los métodos del store global
    const addToCart = cartStore.addToCart;
    const increaseQuantity = cartStore.increaseQuantity;
    const decreaseQuantity = cartStore.decreaseQuantity;
    const getProductQuantity = cartStore.getProductQuantity;
    const totalCajas = computed(() => {
      return cartStore.state.cart.reduce((total, item) => total + item.quantity, 0);
    });

    return {
      addToCart, // Usar el método global para agregar al carrito
      increaseQuantity, // Usar el método global para aumentar la cantidad
      decreaseQuantity, // Usar el método global para disminuir la cantidad
      getProductQuantity,
      totalCajas,

    };
  },
  data() {
    return {
      searchQuery: '',
      products: [],
      cart: [],
      cartDialog: false,
      suggestedItems: [],
      sortByPrice: false,
      dialogFiltro: false,
      selectedBrands: [],  // Para múltiples valores
      selectedBrand: null,
      currentPage: 1,
      hasMoreProducts: true,
      brands: [], // Aseguramos que las marcas estén vacías al inicio
    };
  },
  computed: {

    filteredProducts() {
      let products = this.products.filter((product) => {
        const matchesSearch = product.nombre
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
        const matchesBrand = this.selectedBrand
          ? product.sublinea === this.selectedBrand
          : this.selectedBrands.length > 0
            ? this.selectedBrands.includes(product.sublinea)
            : true;

        return matchesSearch && matchesBrand;
      });
      if (this.sortByPrice) {
        products = products.sort((a, b) => a.price - b.price);
      }

      return products;
    },
  },
  methods: {

    clearCart() {
      this.cart = []; // Vaciar el carrito
      localStorage.removeItem('cart'); // Limpiar el almacenamiento local
    },

    openCart() {
      this.cartDialog = true;
      this.suggestedProducts();
    },

    applyFilters() {

      this.dialogFiltro = false;
    },

async fetchProducts(page = 1) {
  const cacheKey = `vualaCache_page_${page}`;
  const cacheTimeKey = `${cacheKey}_time`;
  const now = Date.now();
  const fiveHours = 5 * 60 * 60 * 1000;

  const cache = localStorage.getItem(cacheKey);
  const cacheTime = localStorage.getItem(cacheTimeKey);

  if (cache && cacheTime && now - cacheTime < fiveHours) {
    const cachedData = JSON.parse(cache);

    this.hasMoreProducts = cachedData.length >= 20;

    this.products = [
      ...this.products,
      ...cachedData.map(product => ({
        ...product,
        price: product.price || 0,
      }))
    ];

    this.brands = [
      ...new Set(this.products.map(product => product.sublinea)),
    ];

    return;
  }

  try {
    const token = localStorage.getItem('token');

    if (!token) {
      console.error('No token found, please login again');
      return;
    }

    const limit = 20;
    const offset = (page - 1) * limit;

    const response = await axios.get('https:///137-vuala', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        limit,
        offset,
      },
    });

    const data = response.data;

    this.hasMoreProducts = data.length >= limit;

    const newProducts = data.map(product => ({
      ...product,
      price: product.price || 0,
    }));

    this.products = [...this.products, ...newProducts];

    this.brands = [
      ...new Set(this.products.map(product => product.sublinea)),
    ];

    // Guardar en caché
    localStorage.setItem(cacheKey, JSON.stringify(data));
    localStorage.setItem(cacheTimeKey, now);
  } catch (error) {
    console.error('Error fetching products:', error.message);
  }
},

    loadMoreProducts() {
      if (this.hasMoreProducts) {
        this.currentPage++;
        this.fetchProducts(this.currentPage);
      }
    },


suggestedProducts() {
  const token = localStorage.getItem("token"); // o donde lo guardes

  axios
    .get("https://mvexpress.mx/api/productos/suggested-products", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      if (Array.isArray(res.data) && res.data.length > 0) {
        this.suggestedItems = res.data;
      } else {
        console.error("No se encontraron productos sugeridos.");
      }
    })
    .catch((err) => {
      console.error("Error fetching suggested products:", err);
    });
},

    handleScroll() {
      const scrollPosition = window.innerHeight + window.scrollY; // Posición actual del scroll
      const bottomPosition = document.documentElement.offsetHeight; // Altura total del documento

      // Si el usuario está cerca del final de la página, cargar más productos
      if (scrollPosition >= bottomPosition - 100 && this.hasMoreProducts) {
        this.loadMoreProducts();
      }
    },
  },
  mounted() {
    const token = localStorage.getItem('token');
    if (!token) {
      window.location.replace('/'); // Redirige y borra el historial
    }

    this.fetchProducts(); // Cargar la primera página de productos al montar el componente

    const saveCart = localStorage.getItem('cart');
    if (saveCart) {
      this.cart = JSON.parse(saveCart);
    }

    // Agregar el evento de scroll
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() { // Cambiado de beforeDestroy a beforeUnmount
    // Eliminar el evento de scroll al destruir el componente
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped>
.main-content {
  padding-bottom: 80px;
  background-image: 'https:///images/naranja%20azul.png';
}



.fixed-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.cart-item {
  padding: 10px 0;
}

.v-dialog .v-card {
  background-color: #ffffff;
}

.v-row {
  margin-bottom: 10px;
}
</style>

<style scoped>
.cart-table {
  width: 100%;
  border-collapse: collapse;
}

.cart-table th,
.cart-table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.cart-table th {
  background-color: #f5f5f5;
  text-align: left;
}

.actions-column {
  width: 150px;
  /* Ajusta el tamaño de la columna de acciones */
  text-align: center;
}

.fixed-cart-btn {
  position: fixed;
  bottom: 70px;
  /* Distancia desde el fondo, ajusta este valor para subir más o bajar el botón */
  left: 50%;
  transform: translateX(-50%);
  /* Centra el botón horizontalmente */
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border-radius: 50px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  font-size: 16px;
}

.v-dialog__content {
  z-index: 9999;
  /* Asegura que el diálogo esté por encima del carrito */
}

.fixed-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 10px;
}

.main-content {
  padding-bottom: 80px;
  /* Asegura que el contenido no quede tapado por el pie de página */
}

v-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #f5f5f5;
  padding: 10px 0;
  text-align: center;
}
</style>